/**
 * Self-hosted DiceBear avatars — seeded by user_id only (no PII).
 * @see frontend/src/design/DESIGN.md (Phase 4 avatar treatment)
 */
import { createAvatar } from '@dicebear/core';
import * as initials from '@dicebear/initials';

/** Bone / pine palette — restrained, editorial */
const BACKGROUND_COLORS = ['e8e4dc', 'ddd8cf', 'd4cfc4', 'c9c4bc'];
const TEXT_COLORS = ['3d4a3a', '4a5946', '5c6b58'];

const cache = new Map();

/**
 * @param {string} userId - Stable UUID (never email)
 * @returns {string} data:image/svg+xml URI
 */
export function getUserAvatarDataUri(userId) {
  if (!userId) return null;
  const key = String(userId);
  if (cache.has(key)) return cache.get(key);

  const avatar = createAvatar(initials, {
    seed: key,
    backgroundColor: BACKGROUND_COLORS,
    textColor: TEXT_COLORS,
    fontFamily: ['Hanken Grotesk', 'system-ui', 'sans-serif'],
    fontWeight: 500,
    radius: 8,
  });

  const uri = avatar.toDataUri();
  cache.set(key, uri);
  return uri;
}

/**
 * Resolve display src: uploaded photo wins over DiceBear.
 * @param {{ userId?: string, avatarUrl?: string|null }} opts
 * @returns {string|null}
 */
export function resolveUserAvatarSrc({ userId, avatarUrl }) {
  const trimmed = (avatarUrl || '').trim();
  if (trimmed) return trimmed;
  return getUserAvatarDataUri(userId);
}
